import script from "./PanelNav.vue?vue&type=script&setup=props&lang=js"
export * from "./PanelNav.vue?vue&type=script&setup=props&lang=js"

import "./PanelNav.vue?vue&type=style&index=0&id=e7db19fa&lang=scss"

export default script